// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-newsie-header-container {
  background-color: rgba(247, 232, 186, 0.397);
  border-radius: 3px;
  border-radius: 3px;
  width: 100%;
  padding: 10px
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/PublicNewsie/PublicNewsie.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX;AACF","sourcesContent":[".public-newsie-header-container {\n  background-color: rgba(247, 232, 186, 0.397);\n  border-radius: 3px;\n  border-radius: 3px;\n  width: 100%;\n  padding: 10px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
